import RADIO from './radio.json';

const RADIO_SET = new Set(RADIO);

export function baseSongId(songOrId) {
  const raw = typeof songOrId === 'string'
    ? songOrId
    : String((songOrId && (songOrId.chartId || songOrId.id)) || '');
  return raw.replace(/-daily-\d{4}-\d{2}-\d{2}$/, '');
}

export function isRadioSong(songOrId) {
  return RADIO_SET.has(baseSongId(songOrId));
}

export function hasOrbitPass(user) {
  return !!(user && (user.isPremium || user.isAdmin));
}

/** Vault songs lock unless the player has an active Orbit Pass. */
export function isLockedSong(song, user) {
  if (hasOrbitPass(user)) return false;
  if (song && song.locked === false) return false;
  if (song && song.access === 'radio') return false;
  if (song && song.access === 'daily') return false;
  if (isRadioSong(song)) return false;
  return true;
}
